export const ORDER = 'ORDER';
export const ORDER_ALL = `${ORDER}/ALL`;
export const ORDER_ACCEPT = `${ORDER}/ACCEPT`;
export const ORDER_REJECT = `${ORDER}/REJECT`;
export const ORDER_COMPLETE = `${ORDER}/COMPLETE`;
export const ORDER_SHIPPED = `${ORDER}/SHIPPED`;
export const ORDER_DETAIL = `${ORDER}/DETAIL`;
export const STRIPE_ORDER_DETAIL = `${ORDER}/STRIPE_DETAIL`;
export const ORDER_RECENT = `${ORDER}/RECENT`;
export const ORDER_TOP = `${ORDER}/TOP`;

export const SEND_RECEIPT = `${ORDER}/SEND_RECEIPT`;
export const EXPORT_ORDERS = `${ORDER}/EXPORT`;
